import { render } from "./SalesReturnBarChart.vue?vue&type=template&id=2ae574a4&scoped=true"
import script from "./SalesReturnBarChart.vue?vue&type=script&lang=js"
export * from "./SalesReturnBarChart.vue?vue&type=script&lang=js"

import "./SalesReturnBarChart.vue?vue&type=style&index=0&id=2ae574a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae574a4"]])

export default __exports__